import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';

import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';
import useTable from 'ui/components/table';

import tableConfig from './table.config';
import Filter from './table.filter';
import { BiAddToQueue } from 'react-icons/bi';
import { Table } from 'services/action';
import { FormPricing } from 'ui/screens/authorized/_shared';
import _ from 'underscore';

const initialState = {
  displayFilter: false,
  count: [],
  privilege: null,
  isShow: false,
};

const SettingPricingScreen = () => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const PricingTable = useTable('pricing', tableConfig);
  const StateTable = useSelector((state) => state?.Table?.data['pricing']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );
  const [{ displayFilter, count, isShow, privilege }, setState] =
    React.useState(initialState);

  const $resetTable = async () => {
    setState((prevState) => ({
      ...prevState,
      isShow: false,
    }));

    Dispatch(Table.$reload('pricing', StateTable));
  };

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  return (
    <div className="sub-page">
      <div className="sub-page-navigation">
        <PricingTable.Tools>
          {(!Session?.privileges || privilege?.action === 'manage') && (
            <button
              onClick={() =>
                setState((prevState) => ({ ...prevState, isShow: true }))
              }
              className="btn btn-primary py-1 ms-1"
            >
              <BiAddToQueue color="white" size="14" />
              <span className="d-none d-md-block ms-2">Tambah Skema Harga</span>
            </button>
          )}
          <Button
            variant={displayFilter ? 'primary' : 'secondary'}
            className="ms-2 position-relative"
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                displayFilter: !displayFilter,
              }))
            }
          >
            <Fi.FiFilter size={19} color="white" />
            {count?.length > 0 ? (
              <span className="position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-danger">
                {count?.length}
              </span>
            ) : null}
          </Button>
        </PricingTable.Tools>
      </div>
      <div className="sub-page-body">
        <div className="row m-0 p-0">
          <div
            className={cn(
              displayFilter ? 'col-md-9  m-0 p-0' : 'col-md-12   m-0 p-0'
            )}
          >
            {StateLoading ? (
              <SkeletonTable headerCount={4} bodyCount={10} />
            ) : (
              <PricingTable.Render />
            )}
          </div>

          <Filter
            JobTable={PricingTable}
            onClose={() =>
              setState((prevState) => ({
                ...prevState,
                displayFilter: false,
              }))
            }
            show={displayFilter}
            setCount={(x) =>
              setState((prevState) => ({
                ...prevState,
                count: x,
              }))
            }
          />
        </div>
      </div>
      <div className="sub-page-footer">
        {StateLoading ? <SkeletonPageFooter /> : <PricingTable.Pagination />}
      </div>

      <Modal
        show={isShow}
        onHide={() =>
          setState((prevState) => ({ ...prevState, isShow: false }))
        }
        backdrop="static"
        centered
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Buat Harga</Modal.Title>
        </Modal.Header>
        <FormPricing
          onClose={() => {
            setState((prevState) => ({ ...prevState, isShow: false }));
          }}
          onSuccess={$resetTable}
        />
      </Modal>
    </div>
  );
};

export default SettingPricingScreen;
